/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Scroll from '@/components/Base/Scroll/indexBeta';
import { mapGetters } from 'vuex';
import FlexCard from '@/components/Common/FlexCard';
export default {
  name: 'GeneralServiceContent',
  props: {
    check: {
      type: Boolean,
      default: false
    },
    pullingDown: {
      type: Function
    },
    pullingUp: {
      type: Function
    },
    dataList: {
      type: Array
    }
  },
  components: {
    Scroll: Scroll,
    FlexCard: FlexCard
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters('global', ['getStateName'])), {}, {
    checkListMsg: function checkListMsg() {
      return this.dataList.filter(function (v) {
        return v._check;
      });
    }
  }),
  methods: {
    forceUpdate: function forceUpdate() {
      var hasMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // 是否加载到最后一页
      this.$refs.scroll.forceUpdate(hasMore);
    },
    scrollToTop: function scrollToTop() {
      this.$refs.scroll.scrollTo(0, 0);
    }
  }
};